import { ReservedRoleNames } from '../../constants';
import { enumValues } from '../../utils';
import { Role } from '../types';

export const getDefaultExecutorRole = (allExecutorRoles: Role[]): Role => {
  const superAdminRole = allExecutorRoles.find(
    (r) => r.name === ReservedRoleNames.SUPERADMIN
  );
  const defaultExecutorRole = (superAdminRole ??
    allExecutorRoles.first()) as Role;
  return defaultExecutorRole;
};

export const reservedRoleNameToTranslatedKeyMap: Record<
  ReservedRoleNames,
  string
> = {
  [ReservedRoleNames.GLOBAL_ACCESS]: `common:permissions.reservedRoleNames.${ReservedRoleNames.GLOBAL_ACCESS}`,
  [ReservedRoleNames.SUPERADMIN]: `common:permissions.reservedRoleNames.${ReservedRoleNames.SUPERADMIN}`,
  [ReservedRoleNames.ADMIN]: `common:permissions.reservedRoleNames.${ReservedRoleNames.ADMIN}`,
};

export const isReservedRoleName = (name: string) => {
  const reservedRoleNames = enumValues(ReservedRoleNames);
  return reservedRoleNames.some((n) => n.toLowerCase() === name.toLowerCase());
};
